/* Rod Armour — variant image preload on hover (Opus 4.7 12-May)
   Reads the product's variants JSON from <textarea data-variant-json> and,
   when the user hovers/focuses a variant option, emits a <link rel="preload">
   for any variant image that isn't already the current selection.
   Effect: variant-swap image change is instant instead of a 100-300ms flash. */
(function () {
  if (typeof document === 'undefined') return;

  var seen = new Set();

  function preloadImage(url) {
    if (!url || seen.has(url)) return;
    seen.add(url);
    var link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = url;
    link.fetchPriority = 'low';
    document.head.appendChild(link);
  }

  function getProductVariants(scope) {
    var ta = scope.querySelector('[data-variant-json]');
    if (!ta || ta.dataset.parsed === 'true') {
      try { return JSON.parse(ta && ta._cachedJSON ? ta._cachedJSON : '[]'); } catch (e) { return []; }
    }
    try {
      var data = JSON.parse(ta.value || ta.textContent);
      ta._cachedJSON = JSON.stringify(data);
      ta.dataset.parsed = 'true';
      return data;
    } catch (e) {
      return [];
    }
  }

  function preloadMatchingVariantImage(scope, optionIndex, optionValue) {
    if (optionValue == null) return;
    var variants = getProductVariants(scope);
    if (!variants || !variants.length) return;
    var optKey = 'option' + (Number(optionIndex) + 1); // option1 / option2 / option3
    var lowered = String(optionValue).toLowerCase().trim();
    variants.forEach(function (v) {
      if (!v || !v[optKey]) return;
      if (String(v[optKey]).toLowerCase().trim() !== lowered) return;
      // Found a matching variant. Preload its featured image if it has one
      // and it differs from any image we've already preloaded.
      var imgUrl =
        (v.featured_image && (v.featured_image.src || v.featured_image)) ||
        v.image ||
        null;
      if (typeof imgUrl === 'string') {
        // Strip protocol-prefixed CDN URL into a width-tuned version
        imgUrl = imgUrl.split('?')[0];
        if (imgUrl.indexOf('//') === 0) imgUrl = 'https:' + imgUrl;
        preloadImage(imgUrl + '?width=720');
      }
    });
  }

  function handleHover(event) {
    var t = event.target;
    if (!t || !t.closest) return;
    // The variant radio carries data-index="option1" / "option2" + the parent label has data-value
    var label = t.closest('[data-value][data-index]');
    if (!label) return;
    var rawIndex = (label.getAttribute('data-index') || '').replace(/^option/, '');
    var idx = parseInt(rawIndex, 10);
    if (isNaN(idx)) return;
    var value = label.getAttribute('data-value');
    var scope = label.closest('.product-section, form[action*="/cart/add"], [data-section-type="product"]') || document;
    preloadMatchingVariantImage(scope, idx, value);
  }

  function init() {
    var opts = { passive: true, capture: true };
    document.addEventListener('mouseover', handleHover, opts);
    document.addEventListener('focusin', handleHover, opts);
    document.addEventListener('touchstart', handleHover, opts);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
